import { render, staticRenderFns } from "./OsoiteKappale.vue?vue&type=template&id=24e11e56&scoped=true&"
import script from "./OsoiteKappale.vue?vue&type=script&lang=js&"
export * from "./OsoiteKappale.vue?vue&type=script&lang=js&"
import style0 from "./OsoiteKappale.vue?vue&type=style&index=0&id=24e11e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e11e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e11e56')) {
      api.createRecord('24e11e56', component.options)
    } else {
      api.reload('24e11e56', component.options)
    }
    module.hot.accept("./OsoiteKappale.vue?vue&type=template&id=24e11e56&scoped=true&", function () {
      api.rerender('24e11e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OsoiteKappale.vue"
export default component.exports